window.jQuery = require('jquery');
require('./../../target/node_modules/vecna-javascript/jquery.print');
var _ = require('underscore');
var TorsoCell = require('backbone-torso/modules/Cell');

var launcherAppInterface = require('./../launcherApplicationInterface');
var logoutUtils = require('./../authentication/logoutUtils');

var AsideBehavior = require('./../aside/AsideBehavior');
var PortalPerspectiveLayoutBehavior = require('./../PortalPerspectiveLayoutBehavior');
var DemographicsDataBehavior = require('./../demographics/DemographicsDataBehavior');
var AppointmentInstructionListWidget = require('./AppointmentInstructionListWidget');
var LayoutPerspective = require('./../layout/LayoutPerspective');
var ModalDialogWidget = require('./../widget/modal/ModalDialogWidget');
var multiAppointmentConfirmationTemplate = require('./multiAppointmentConfirmationTemplate.hbs');
var onsiteConfigModel = require('./../onsite-config/onsiteConfigModel');
var wizardUtils = require('./../wizard/wizardUtils');

/**
 * Perspective to display the Multiple Appointment Confirmation page
 *
 * @class MultiAppointmentConfirmationPerspective
 * @param options {Object} Options to configure this perspective.
 *   @param [options.patientVecnaId] {String} the vecna id of the current patient
 *   @param [options.appointmentExternalId] {String} the external id of the current appointment
 */
module.exports = LayoutPerspective.extend({
  template: multiAppointmentConfirmationTemplate,
  moduleNamespace: 'multiAppointmentConfirmationPerspective',

  behaviors: {
    portalPerspectiveLayoutBehavior: PortalPerspectiveLayoutBehavior,
    asideBehavior: {
      behavior: AsideBehavior,
      asideHeaderMessageKey: 'aside.information.header',
      asideContentMessageKey: 'appointmentDetail.aside'
    },
    demographics: {
      behavior: DemographicsDataBehavior,
      returnSingleResult: true,
      ids: { property: '_patientVecnaId' }
    }
  },

  events: _.extend({}, LayoutPerspective.prototype.events, {
    'click [data-print]' : '_print',
    'click [data-ereg-signout]' : '_logout'
  }),

  injectionSites: {
    'appointment-instructions': '_appointmentInstructionsListWidget'
  },

  prepareFields: {
    barcodeCheckInEnabled: function() {
      return onsiteConfigModel && onsiteConfigModel.get('barcodeEnabled');
    },
    barcodeUrl: function() {
      var barcodeAllowedForAnyAppointment = this._barcodeState.get('barcodeAllowed');
      var barcodeCheckInEnabled = onsiteConfigModel && onsiteConfigModel.get('barcodeEnabled');
      if (barcodeCheckInEnabled && barcodeAllowedForAnyAppointment) {
        return this._barcodeState.get('barcodeUrl');
      }
      return null;
    },
    isAtHospital: function() {
      return launcherAppInterface.isAtHospital();
    },
    patientVecnaId: '_patientVecnaId'
  },

  /**
   * @method initialize
   * @override
   * @param options {Object} Options to configure this perspective.
   *   @param [options.patientVecnaId] {String} the vecna id of the current patient
   *   @param [options.appointmentExternalId] {String} the external id of the current appointment
   *   @param [options.regDate] {String} the date for the appointments
   */
  initialize: function(options) {
    LayoutPerspective.prototype.initialize.apply(this);
    _.bindAll(this, 'render');

    this._patientVecnaId = options.patientVecnaId;
    this._regDate = options.regDate;
    this._appointmentExternalIds =
        wizardUtils.getSelectedPreRegWizardAppointmentExternalIds(null, this._regDate);
    this._barcodeState = new TorsoCell({
      barcodeAllowed: false,
      barcodeUrl: null
    });

    this._appointmentInstructionsListWidget = new AppointmentInstructionListWidget({
      appointmentExternalIds: this._appointmentExternalIds,
      patientVecnaId: this._patientVecnaId,
      barcodeState: this._barcodeState
    });

    onsiteConfigModel.loadOnce();
    this.listenTo(onsiteConfigModel, 'change:barcodeEnabled', this.render);
    this.listenTo(this._barcodeState, 'change:barcodeUrl change:barcodeAllowed', this.render);
  },

  /**
   * Prints this view.
   * @method _print
   * @param event {jQuery.Event} the event that triggered this call to print.
   * @private
   */
  _print: function(event) {
    event.preventDefault();
    this.$el.find('[data-confirmation-pane]').print();
    return false;
  },

  /**
   * Instantiates a confirmation popup for logout, and logs the user out if it returns true.
   * @method _logout
   * @param event {Object} the event object
   * @private
   */
  _logout: function(event) {
    event.preventDefault();

    var dataViewName = 'confirm signout';
    var logoutCallBack = logoutUtils.logoutWithRedirect;

    if (launcherAppInterface.isAtHospital()) {
      dataViewName = 'confirm ereg signout';
      logoutCallBack = logoutUtils.patientLogoutWithRedirectToEreg;
    }

    this._modalDialogWidget = new ModalDialogWidget({
      dataViewName: dataViewName,
      descriptionKey: 'nav.signOutModal.body',
      yesKey: 'nav.signOutModal.signOut',
      noKey: 'nav.signOutModal.stay'
    });
    this.showModal(this._modalDialogWidget, logoutCallBack);
  }
});
